<section [formGroup]="loan.form">
  <mat-form-field>
    <mat-select placeholder="How did you know about us?" required formControlName="application_source">
      <ng-container *ngFor="let source of source.list|async">
        <mat-option [value]="source.id">
          {{ source.name }}
        </mat-option>
      </ng-container>
    </mat-select>
    <mat-error *ngIf="loan.form.get('application_source').hasError('required')">Required.</mat-error>
  </mat-form-field>
</section>
